var map = {
	"./en/society.json": [
		34740,
		4740
	],
	"./fr/society.json": [
		36847,
		6847
	],
	"./nl/society.json": [
		29749,
		9749
	],
	"./zh/society.json": [
		17757,
		7757
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3465;
module.exports = webpackAsyncContext;